module.exports = __webpack_public_path__ + "static/media/male-18.557a07f7.png";